/**
 * Common emoji constants for Community components
 * These emojis are used across Comment, Post, and CreatePost components
 */

export interface EmojiItem {
  emoji: string;
  labelKey: string;
}

/**
 * Construction-themed emojis for posts, comments, and replies
 */
export const CONSTRUCTION_EMOJIS: EmojiItem[] = [
  { emoji: '👷', labelKey: 'community.emojis.worker' },
  { emoji: '🏗️', labelKey: 'community.emojis.construction' },
  { emoji: '🔨', labelKey: 'community.emojis.hammer' },
  { emoji: '🔧', labelKey: 'community.emojis.wrench' },
  { emoji: '⚙️', labelKey: 'community.emojis.gear' },
  { emoji: '🪛', labelKey: 'community.emojis.screwdriver' },
  { emoji: '🧰', labelKey: 'community.emojis.toolbox' },
  { emoji: '🏢', labelKey: 'community.emojis.building' },
  { emoji: '🚧', labelKey: 'community.emojis.under_construction' },
  { emoji: '⛏️', labelKey: 'community.emojis.pick' },
  { emoji: '🪚', labelKey: 'community.emojis.saw' },
  { emoji: '⚡', labelKey: 'community.emojis.electricity' },
  { emoji: '💪', labelKey: 'community.emojis.strong' },
  { emoji: '✅', labelKey: 'community.emojis.done' },
  { emoji: '⚠️', labelKey: 'community.emojis.caution' },
  { emoji: '🎯', labelKey: 'community.emojis.target' },
];

/**
 * Common emojis for general use in posts
 */
export const COMMON_EMOJIS: EmojiItem[] = [
  { emoji: '😊', labelKey: 'community.emojis.smile' },
  { emoji: '👍', labelKey: 'community.emojis.thumbs_up' },
  { emoji: '❤️', labelKey: 'community.emojis.love' },
  { emoji: '😂', labelKey: 'community.emojis.laughing' },
  { emoji: '🎉', labelKey: 'community.emojis.celebration' },
  { emoji: '🔥', labelKey: 'community.emojis.fire' },
  { emoji: '👏', labelKey: 'community.emojis.clapping' },
  { emoji: '💯', labelKey: 'community.emojis.hundred' },
];

/**
 * Reaction emojis for comments (compact version)
 */
export const COMMENT_REACTIONS: EmojiItem[] = [
  { emoji: '👍', labelKey: 'community.emojis.like' },
  { emoji: '❤️', labelKey: 'community.emojis.love' },
  { emoji: '💪', labelKey: 'community.emojis.strong' },
  { emoji: '👷', labelKey: 'community.emojis.pro' },
  { emoji: '🔨', labelKey: 'community.emojis.nailed_it' },
  { emoji: '✅', labelKey: 'community.emojis.done' },
];

/**
 * Reaction emojis for posts (extended version)
 */
export const POST_REACTIONS: EmojiItem[] = [
  { emoji: '👍', labelKey: 'community.emojis.like' },
  { emoji: '❤️', labelKey: 'community.emojis.love' },
  { emoji: '💪', labelKey: 'community.emojis.strong_work' },
  { emoji: '👷', labelKey: 'community.emojis.pro' },
  { emoji: '🔨', labelKey: 'community.emojis.nailed_it' },
  { emoji: '✅', labelKey: 'community.emojis.done' },
  { emoji: '🏗️', labelKey: 'community.emojis.building' },
  { emoji: '🔥', labelKey: 'community.emojis.fire' },
  { emoji: '⚡', labelKey: 'community.emojis.power' },
];
